import React, { useContext, useEffect, useState } from 'react'
import { LoadingFull, LoadingOverlay } from '../../loading';
import axios from 'axios';
import { UserContext } from '../../../App';

const Overview = ({stripeUser, setStripeUser}) => {

  const [load, setLoad] = useState(false)
  const [error, setError] = useState('')
  const { auth, user } = useContext(UserContext)
  const token = localStorage.getItem('token')
  
  function payout() {
    setError('')
    setLoad(true)
    axios({
        method: 'post',
        url: '/api/payout',
        data: {
            'stripeId': user.stripeId,
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      setStripeUser(response.data)
      setLoad(false)
    })
    .catch(error => {
      console.log(error);
      setError(error.response.data.msg)
      setLoad(false)
    });
  }

  return (
    <div className="w-full h-fit lg:h-full border border-gray-100 shadow-lg relative">
      {(load) ?
        <LoadingOverlay />
      :
        ""}
      <div className="h-full bankInfo px-10 py-5 text-sm md:text-base flex flex-col justify-center gap-2">
        {(error !== '') ? <h2 className="text-sm font-medium text-red-500">{error}</h2> : ""}
        {(typeof stripeUser !== 'undefined') ?
          <div className="flex flex-col sm:flex-row gap-5 justify-between items-center">
            <div className="flex flex-col gap-2">
              <p className="text-sm">Tilgængelig saldo</p>
              <h2 className="font-bold text-2xl">{Number(stripeUser.balance.available[0].amount/100).toFixed(2).toString().replace(/\./g, ',')} kr.</h2>
            </div>
            <div className={"w-full sm:w-fit text-center font-medium px-5 py-2 bg-gradient-to-r from-emerald-600 to-emerald-800 bg-size-200 bg-pos-0 hover:bg-pos-100 text-white cursor-pointer transition-[]"} onClick={payout}>Udbetal</div>
          </div>
        :
          <LoadingFull />
        }
      </div>
    </div>
  )
}

export default Overview